import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IFaxFolder } from "src/app/models/fax/fax-folder";
import { IFaxRule } from "src/app/models/fax/fax-rule";

@Component({
  selector: "app-fax-rule-list",
  templateUrl: "./fax-rule-list.component.html",
  styleUrls: ["./fax-rule-list.component.scss"],
})
export class FaxRuleListComponent {
  @Input() items: IFaxRule[] = [];
  @Input() folders: IFaxFolder[] = [];
  @Input() isLoading = false;

  readonly skeletonRows = [1, 2, 3];

  @Output() editClick = new EventEmitter<IFaxRule>();
  @Output() createClick = new EventEmitter<void>();
  @Output() deleteClick = new EventEmitter<IFaxRule>();

  selectedRule: IFaxRule | null = null;

  get selectedRuleName() {
    return this.selectedRule !== null ? this.formatRuleToString(this.selectedRule) : "";
  }

  selectRule(folder: IFaxRule) {
    this.selectedRule = folder;
  }

  deselectRule() {
    this.selectedRule = null;
  }

  formatRuleToString(rule: IFaxRule) {
    return `${rule.triggerOn}: ${rule.direction} ${rule.trackingFaxNumber} - ${this.getFolderName(rule)}`;
  }

  private getFolderName(rule: IFaxRule) {
    return this.folders.find(folder => folder.id === rule.folderId)?.name ?? String(rule.folderId);
  }

  onCreateClick() {
    this.createClick.emit();
  }

  onDeleteClick() {
    if (this.selectedRule !== null) {
      this.deleteClick.emit(this.selectedRule);
    }
  }
}
